@switch (this.body().Type) {
  @case ('TaskMerged') {
    <cam-switch-cases-task-merged
      [case]="$any(this.body())"
      [conversationParticipants]="this.conversationParticipants()"
    ></cam-switch-cases-task-merged>
  }
  @case ('TypeChanged') {
    <cam-switch-cases-type-changed
      [case]="$any(this.body())"
      [conversationParticipants]="this.conversationParticipants()"
    ></cam-switch-cases-type-changed>
  }
  @case ('SubTypeChanged') {
    <cam-switch-cases-sub-type-changed
      [case]="$any(this.body())"
      [conversationParticipants]="this.conversationParticipants()"
    ></cam-switch-cases-sub-type-changed>
  }
  @case ('TaskStatusChanged') {
    <cam-switch-cases-task-status-changed
      [case]="$any(this.body())"
      [conversationParticipants]="this.conversationParticipants()"
    ></cam-switch-cases-task-status-changed>
  }
  @case ('ToDoAdded') {
    <cam-switch-cases-to-do-added
      [case]="$any(this.body())"
      [conversationParticipants]="this.conversationParticipants()"
    ></cam-switch-cases-to-do-added>
  }
  @case ('ToDoClosed') {
    <cam-switch-cases-to-do-closed
      [case]="$any(this.body())"
      [conversationParticipants]="this.conversationParticipants()"
    ></cam-switch-cases-to-do-closed>
  }
  @case ('AssigneeChanged') {
    <cam-switch-cases-assignee-changed
      [case]="$any(this.body())"
      [conversationParticipants]="this.conversationParticipants()"
    ></cam-switch-cases-assignee-changed>
  }
  @case ('SubTaskCreated') {
    <cam-switch-cases-sub-task-created
      [case]="$any(this.body())"
      [conversationParticipants]="this.conversationParticipants()"
    ></cam-switch-cases-sub-task-created>
  }
  @case ('CriticityChanged') {
    <cam-switch-cases-criticity-changed
      [case]="$any(this.body())"
      [conversationParticipants]="this.conversationParticipants()"
    ></cam-switch-cases-criticity-changed>
  }
  @case ('TeamChanged') {
    <cam-switch-cases-team-changed
      [case]="$any(this.body())"
      [conversationParticipants]="this.conversationParticipants()"
    ></cam-switch-cases-team-changed>
  }
}
